const NBSP = ' ';

/**
 * French typesetting: a one-letter word (à, a, y, ô) never ends a line. Binds it to the
 * next word with a non-breaking space. Presentational only, the copy is unchanged.
 */
export function glue(text: string): string {
	return text.replace(/(^|[\s ])([aàyôAÀYÔ]) /g, `$1$2${NBSP}`);
}

/** Two-letter monogram of a sender name ("Atelier Mercier" gives "AM"). */
export function initials(name: string): string {
	return name
		.split(/\s+/)
		.filter(Boolean)
		.slice(0, 2)
		.map((word) => word.charAt(0))
		.join('')
		.toUpperCase();
}

export type BodySegment = { text: string; mark?: number };

/**
 * Splits a message body around the values the agent extracts, so each value can be
 * marked where it was found. Values that do not appear verbatim are simply not marked.
 */
export function segmentBody(body: string, values: string[]): BodySegment[] {
	const found = values
		.map((value, index) => ({ index, start: value ? body.indexOf(value) : -1, length: value.length }))
		.filter((hit) => hit.start >= 0)
		.sort((a, b) => a.start - b.start);

	const segments: BodySegment[] = [];
	let cursor = 0;
	found.forEach((hit) => {
		if (hit.start < cursor) return;
		if (hit.start > cursor) segments.push({ text: body.slice(cursor, hit.start) });
		segments.push({ text: body.slice(hit.start, hit.start + hit.length), mark: hit.index });
		cursor = hit.start + hit.length;
	});
	if (cursor < body.length) segments.push({ text: body.slice(cursor) });
	return segments;
}
